<template>
	<div class="modal fade show" tabindex="-1" role="dialog" style="display: block; background: rgba(0, 0, 0, 0.5);">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h5 class="modal-title">Associa nota spesa a progetto</h5>
					<button type="button" class="btn-close btn-close-white" @click="close()"></button>
				</div>

				<div class="modal-body">
					<!-- Dettagli nota (read-only) -->
					<div class="card mb-3 border-secondary">
						<div class="card-body p-2">
							<div class="row g-2">
								<div class="col-3">
									<small class="text-muted d-block">Data</small>
									<div class="fw-500">{{ formatData(notaSpesa.DATA) }}</div>
								</div>
								<div class="col-3">
									<small class="text-muted d-block">Importo</small>
									<div :style="{ color: getImportoColor(notaSpesa) }" class="fw-bold">
										{{ getImportoSign(notaSpesa) }} € {{ formatImporto(notaSpesa.IMPORTO) }}
									</div>
								</div>
								<div class="col-6">
									<small class="text-muted d-block">Descrizione</small>
									<div>{{ notaSpesa.DESCRIZIONE }}</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Form associazione -->
					<form @submit.prevent="saveAssociazione">
						<div class="mb-3">
							<label class="form-label">Progetto *</label>
							<select v-model="selectedProgetto" class="form-control" required :disabled="loadingProgetti">
								<option value="">Seleziona un progetto...</option>
								<option v-for="p in arrayProgetti" :key="p.ID_PROGETTO" :value="p.ID_PROGETTO">
									{{ p.TITOLO }}
								</option>
							</select>
						</div>

						<div v-if="message" class="alert" :class="messageClass" role="alert">
							{{ message }}
						</div>

						<!-- Upload e Anteprima allegato -->
						<div class="row mb-3" style="align-items: stretch;">
							<div class="col-sm-6 d-flex flex-column">
								<label class="form-label text-center">Allegato / Scontrino</label>
								<div style="flex: 1;">
									<Upload
										url="core/basic/upload"
										:args="{ modalita: 'THEB_uploadAllegatoSpesa', ID_NOTA_SPESA: notaSpesa.ID_NOTA_SPESA }"
										@onsuccess="onUploadSuccess"
										@onerror="onUploadError"
									/>
								</div>
							</div>
							<div class="col-sm-6 d-flex flex-column" v-if="allegatoInfo">
								<label class="form-label text-center">Anteprima allegato</label>
								<div class="card" style="flex: 1; margin-top: 20px;">
									<div class="card-body text-center">
										<img v-if="allegatoInfo.isImmagine" :src="allegatoInfo.url" :alt="allegatoInfo.nome" style="max-width: 100%; max-height: 200px; margin-bottom: 10px;">
										<div v-else-if="allegatoInfo.isPdf">
											<p><i class="fas fa-file-pdf" style="font-size: 30px; color: #d32f2f;"></i></p>
										</div>
										<p class="small mt-2 text-muted">{{ allegatoInfo.nome }}</p>
									</div>
								</div>
							</div>
						</div>

						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" @click="close()">Annulla</button>
							<button type="submit" class="btn btn-primary" :disabled="loading || !selectedProgetto">
								<span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
								Associa al progetto
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Upload from './utils/Upload.vue';

export default {
	name: 'ModalAssociaNotaSpesa',
	components: {
		Upload
	},
	props: {
		notaSpesa: {
			type: Object,
			required: true
		}
	},
	emits: ['close', 'saved'],
	data() {
		return {
			selectedProgetto: '',
			arrayProgetti: [],
			loadingProgetti: false,
			loading: false,
			message: '',
			messageClass: '',
			allegatoInfo: null,
			notaSpesa_FILE_ALLEGATO: null
		};
	},
	watch: {
		notaSpesa: {
			immediate: true,
			handler(nota) {
				if (nota && nota.FILE_ALLEGATO) {
					const filePath = nota.FILE_ALLEGATO;
					const fileName = filePath.split(/[\\/]/).pop() || 'Allegato';
					const isPdf = filePath.toLowerCase().endsWith('.pdf');
					const isImmagine = /\.(jpg|jpeg|png|gif|webp)$/i.test(filePath);
					this.allegatoInfo = {
						nome: fileName,
						url: this.getAllegatoPath(filePath),
						isPdf,
						isImmagine
					};
				} else {
					this.allegatoInfo = null;
				}
				this.selectedProgetto = nota.FK_ID_PROGETTO || '';
				this.notaSpesa_FILE_ALLEGATO = null;
				this.message = '';
				this.messageClass = '';
			}
		}
	},
	methods: {
		getAllegatoPath(filePath) {
			if (!filePath) return '';
			const baseUpload = utils.BASE_API + '../../../../thebproject/UPLOAD/';
			return baseUpload + filePath.replace(/\\/g, '/');
		},
		saveAssociazione() {
			if (!this.selectedProgetto) {
				this.message = 'Seleziona un progetto';
				this.messageClass = 'alert-warning';
				return;
			}

			this.loading = true;
			this.message = '';

			const payload = {
				ID_NOTA_SPESA: this.notaSpesa.ID_NOTA_SPESA,
				FK_ID_UTENTE: this.notaSpesa.FK_ID_UTENTE,
				DATA: this.notaSpesa.DATA,
				IMPORTO: this.notaSpesa.IMPORTO,
				TIPO_MOVIMENTO: this.notaSpesa.TIPO_MOVIMENTO,
				DESCRIZIONE: this.notaSpesa.DESCRIZIONE,
				FK_ID_PROGETTO: this.selectedProgetto,
				FLG_ATTIVO: this.notaSpesa.FLG_ATTIVO,
				FK_ID_CATEGORIA: this.notaSpesa.FK_ID_CATEGORIA,
				FILE_ALLEGATO: this.notaSpesa_FILE_ALLEGATO || this.notaSpesa.FILE_ALLEGATO
			};

			utils.ajax('theb/notaspesa/update', payload, (res) => {
				this.loading = false;
				if (res.esito == 0) {
					this.$emit('saved');
					this.close();
				} else {
					this.message = res.messaggio || 'Errore nel salvataggio';
					this.messageClass = 'alert-danger';
				}
			});
		},
		onUploadSuccess(res) {
			const filePath = res.data?.file_path || res.file_path || '';
			const fileName = filePath.split('\\').pop() || 'Allegato';
			const isPdf = filePath.toLowerCase().endsWith('.pdf');
			const isImmagine = /\.(jpg|jpeg|png|gif|webp)$/i.test(filePath);

			this.allegatoInfo = {
				nome: fileName,
				url: this.getAllegatoPath(filePath),
				isPdf,
				isImmagine
			};

			// Memorizza il file path per il salvataggio successivo
			this.notaSpesa_FILE_ALLEGATO = filePath;
			utils.alert.success('Allegato caricato');
		},
		onUploadError() {
			utils.alert.warning('Errore upload allegato');
		},
		close() {
			this.$emit('close');
		},
		formatData(data) {
			if (!data) return '';
			const d = new Date(data);
			return d.toLocaleDateString('it-IT');
		},
		formatImporto(importo) {
			if (!importo) return '0.00';
			return Math.abs(parseFloat(importo)).toFixed(2);
		},
		getImportoSign(nota) {
			return nota.TIPO_MOVIMENTO === 0 ? '−' : '+';
		},
		getImportoColor(nota) {
			return nota.TIPO_MOVIMENTO === 0 ? '#dc3545' : '#28a745';
		}
	},
	mounted() {
		this.loadingProgetti = true;
		utils.ajax('theb/progetti', {}, (res) => {
			if (res.esito == 0) {
				this.arrayProgetti = res.data || [];
			}
			this.loadingProgetti = false;
		});
	}
};
</script>

<style scoped>
.modal {
	z-index: 1050;
}

.modal.show {
	background-color: rgba(0, 0, 0, 0.5);
}
</style>
